// extracted by mini-css-extract-plugin
module.exports = {"backContainer":"index_backContainer__9EmsH","topDiv":"index_topDiv__CPTnc","mainItem":"index_mainItem__ORPfA"};